import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/ui/Box/MDBox";
import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";

export default function EditModeBulkSelectionButtons({ onSelectAll, onClearAll }) {
  return (
    <MDBox
      sx={{
        width: "100%",
        display: "flex",
        gap: 1,
      }}
    >
      <Button
        variant="text"
        fullWidth
        onClick={onSelectAll}
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.78rem",
          py: 0.8,
          color: "primary.main",
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
          "&:hover": {
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.16),
          },
        }}
      >
        Seleccionar slots
      </Button>

      <Button
        variant="text"
        fullWidth
        onClick={onClearAll}
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.78rem",
          py: 0.8,
          color: "text.secondary",
          backgroundColor: "grey.100",
          "&:hover": {
            backgroundColor: "grey.200",
          },
        }}
      >
        Limpiar selección
      </Button>
    </MDBox>
  );
}

EditModeBulkSelectionButtons.propTypes = {
  onSelectAll: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};
